import { loadScript } from '@/util/index'
import _ from 'lodash'
import API from '@/api'
import ThirdPartyRegistration from '@/views/home/components/ThirdPartyRegistration.vue'
// import bus from '@/util/bus'
import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'
import store from '@/store'

export default {
  components: {
    'third-party-registration': ThirdPartyRegistration
  },
  data() {
    return {
      isClickGoogle: false,
      thirdPartyRegistrationVisibled: false,
      thirdPartyLoginForm: {
        loginThirdType: undefined,
        loginThirdkey: '',
        email: '',
        fullName: ''
      },
      toPage: '/'
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // if (from.matched.length && from.matched[0].components.default.__file.includes('IndexLayout')) vm.toPage = '/index'
      // else vm.toPage = '/'
      vm.toPage = from.fullPath
    })
  },
  mounted() {
    this.setGoogleLoginSuccessCb()
    loadScript('https://apis.google.com/js/platform.js', null, { catch: false })
  },
  methods: {
    /**
     * 设置谷歌登录成功回调函数
     */
    setGoogleLoginSuccessCb() {
      window.googleLoginSuccessCb = this.googleLoginSuccessCb.bind(this)
    },
    /**
     * 谷歌成功回调函数
     */
    googleLoginSuccessCb(googleUser) {
      // console.log('谷歌成功回调函数', googleUser, this.isClickGoogle)
      if (!this.isClickGoogle) return
      // 由于id_token外层字段会经常变化，递归取值
      let id_token = ''
      function getIdToken(obj) {
        Object.keys(obj).forEach((key) => {
          if (key === 'id_token') {
            id_token = obj[key]
          } else if (typeof obj[key] !== 'string') getIdToken(obj[key])
        })
      }
      getIdToken(googleUser)
      if (!id_token) throw new Error(`谷歌登录回调函数，未获取到id_token`)
      // 字段会变化，直接解析token
      const userInfo = jwtDecode(id_token)
      this.thirdPartyLoginForm = {
        loginThirdType: 1,
        loginThirdkey: id_token,
        email: userInfo.email,
        fullName: userInfo.name
      }
      this.thirdPartyAccountIsBinded(1, id_token)
    },
    /**
     * 检查第三方账号是否绑定kaka账号
     * loginThirdType 第三方登录类型 1：谷歌（第三方登录时传）
     * loginThirdkey 第三方登录获取唯一绑定值字符串（第三方登录时传）
     */
    thirdPartyAccountIsBinded(loginThirdType, loginThirdkey) {
      if (!loginThirdType || !loginThirdkey) return
      API.thirdPartyAccountIsBinded({ loginThirdType, loginThirdkey })
        .then((result) => {
          if (result.code !== 10000) {
            return this.$refs.thirdPartyRegistration.show(this.thirdPartyLoginForm)
          }
          // 第三方账号已绑定
          this.thirdPartyLogin()
        })
        .catch(() => {
          this.$refs.thirdPartyRegistration.show(this.thirdPartyLoginForm)
        })
    },
    /**
     * 第三方登录
     */
    thirdPartyLogin() {
      let data = new FormData()
      data.append('grant_type', 'google')
      data.append('client_id', 'google_web')
      data.append('client_secret', 'google_web_secret')
      data.append('loginThirdkey', this.thirdPartyLoginForm.loginThirdkey)

      API.login(data)
        .then(this.loginSuccessCb)
        .catch((result) => {
          this.$message.error(result.data.message)
        })
    },
    /**
     * 调用登录接口成功后回调
     */
    loginSuccessCb(result) {
      if (result.code !== 10000) return this.$message.error(result.message)
      const roles = result.data.authorities
      // 用户端只有角色是1才能登陆
      if (!roles.includes('1')) return this.$message.error(this.$t('promptText.msg34'))
      this.$store.commit('common/set', {
        token: result.data.accessToken,
        userId: result.data.userId,
        userName: result.data.fullName,
        email: result.data.email || _.get(this, 'thirdPartyLoginForm.email', ''),
        phone: result.data.phone,
        jti: result.data.jti,
        authorities: roles
      })

      // 将token存储到主域名中的cookies中
      Cookies.set('token', result.data.accessToken, { expires: 1, path: '/', domain: `${process.env.VUE_APP_DOMAIN}`, secure: false })
      Cookies.set('userId', result.data.userId, { expires: 1, path: '/', domain: `${process.env.VUE_APP_DOMAIN}`, secure: false })
      Cookies.set('userName', result.data.fullName, { expires: 1, path: '/', domain: `${process.env.VUE_APP_DOMAIN}`, secure: false })
      Cookies.set('email', result.data.email || _.get(this, 'thirdPartyLoginForm.email', ''), { expires: 1, path: '/', domain: `${process.env.VUE_APP_DOMAIN}`, secure: false })
      Cookies.set('phone', result.data.phone, { expires: 1, path: '/', domain: `${process.env.VUE_APP_DOMAIN}`, secure: false })
      Cookies.set('jti', result.data.jti, { expires: 1, path: '/', domain: `${process.env.VUE_APP_DOMAIN}`, secure: false })
      Cookies.set('authorities', roles, { expires: 1, path: '/', domain: `${process.env.VUE_APP_DOMAIN}`, secure: false })

      localStorage.setItem('reset_login_state', !JSON.parse(localStorage.getItem('reset_login_state')))
      API.getUserInfo(result.data.userId).then(res => {
        const { userGroup, fullName, ifAutomaticPayment, inviteCode, virtualWarehouseId, approvalStatus } = res.data
        store.commit('common/set', { userGroup, fullName, ifAutomaticPayment, inviteCode, virtualWarehouseId, approvalStatus })
      })
      // // 未登录的购物车商品加入到登录后的购物车里
      // const cartParams = this.$store.state.common.cartList.map((item) => ({
      //   warehouseCode: item.warehouseCode,
      //   skuCode: item.skuCode,
      //   kkProductId: item.kkProductId,
      //   num: item.num
      // }))
      // API.addBatchCart({ cartParams }).then((result) => {
      //   bus.$emit('getCartList')
      // })
      if (localStorage.getItem('isSeller') && localStorage.getItem('isSeller') === 'true') {
        this.$router.push('/certificate')
        return
      }
      const loginRedirection = JSON.parse(localStorage.getItem('loginRedirection'))
      if (loginRedirection) {
        // if (loginRedirection.path.includes('/product-detail') || loginRedirection.path.includes('/product-list') || loginRedirection.path.includes('/album/') || loginRedirection.path === '/mall') {
        let query = loginRedirection.query
        let param = '?'
        for (let key in query) {
          param += `${key}=${query[key]}&`
        }
        param.slice(0, -1)
        location.href = `${loginRedirection.path}${Object.keys(query).length ? param : ''}`
        // } else {
        //   this.$router.push({
        //     path: loginRedirection.path,
        //     query: loginRedirection.query
        //   })
        // }
        localStorage.removeItem('loginRedirection')
      } else if (this.$store.state.common.selectedKKProductId) {
        // this.$router.push({
        //   path: '/mall/product-detail',
        //   query: { id: this.$store.state.common.selectedKKProductId }
        // })
        this.jumpDetailSeo(this.$store.state.common.selectedKKProductId)
      } else if (this.$store.state.common.fastLogin) {
        console.log('快速创建用户')
      } else {
        if (this.toPage.includes('/register') || this.toPage.includes('/certificate') || this.toPage.includes('/login') || this.toPage.includes('/login/') || this.toPage.includes('/')) {
          location.href = '/'
          // this.$router.push('/')
          return
        }
        this.$router.push(this.toPage)
      }

      // 获取收货地址列表
      this.$store.dispatch('common/getAddressList')
      // 获取用户余额
      this.$store.dispatch('common/getBalance')
      // 获取国家下拉框列表
      this.$store.dispatch('common/getCountrySelectList')
      // 获取平台数据
      this.$store.dispatch('common/getPlatformOptions')
      this.$store.dispatch('common/getCategoryTree')
      // 数据埋点，用户上线时间
      this.getEmailStatus()
      this.createLoginLog()
    },
    getEquipmentName() {
      var cBrowser = ''
      if (window.navigator.userAgent.indexOf('Safari') >= 0 && navigator.userAgent.toLowerCase().indexOf('version') >= 0) {
        cBrowser = 'Safari'
      } else if (window.navigator.userAgent.indexOf('Chrome') >= 0) {
        cBrowser = 'Chrome'
      } else if (navigator.userAgent.toLowerCase().indexOf('msie') >= 0) {
        cBrowser = 'Ie'
      } else if (navigator.userAgent.toLowerCase().indexOf('firefox') >= 0) {
        cBrowser = 'Firefox'
      } else if (navigator.userAgent.toLowerCase().indexOf('opera') >= 0) {
        cBrowser = 'Opera'
      }
      return `${cBrowser} on ${this.isPC ? 'Windows' : 'Mobile'}`
    },
    createLoginLog() {
      let data = {
        ipAddress: this.$store.state.common.ipInfoObjec.ip,
        loginType: 1,
        loginAddress: this.$store.state.common.ipInfoObjec.country,
        equipmentType: this.getEquipmentName()
      }
      API.createLoginLog(data).then(() => {})
    },
    // 获取用户邮箱是否已认证
    getEmailStatus() {
      API.getEmailStatus().then(result => {
        this.$store.commit('common/set', { isAuthentication: +result.data === 1 })
      })
    }
  }
}
